import { lazy } from "react";

export const CreateArticleAsync = lazy(() => import("./CreateArticle"));
